﻿@if(showDebugPanel()) {

<div class="hidden max-w-md border border-solid border-black p-4 md:block">
    <div class="overflow-auto">
        <strong>Form Value:</strong>
        <pre>{{ formValue() | json }}</pre>
    </div>
    <div>
        <strong>Form Valid:</strong>
        <span> {{ formValid() }} </span>
    </div>
    <div>
        <strong>Form Dirty:</strong>
        <span> {{ formDirty() }} </span>
    </div>
</div>

}
